const en = {
  '赞助和游戏责任': 'Sponsorship and Gaming Responsibility',
  '产品': 'Products',
  '游戏': 'Games',
  "announcement": 'Dive into the thrill and experience the excitement of our online games today! Explore a world of opportunities where fun and rewards are just around the corner!',
  '排名': 'Ranking',
  "更多的": "More",
  "拱廊": "Arcade",
  "撞车游戏": "Crash Games",
  "钓鱼游戏": "Fish Games",
  "直播": "Live",
  "登录": "Log In",
  "注册": 'Register',
  "选择语言": 'Language',
  "介绍人": "Introducer",
  "账号": "Account",
  "密码": "Password",
  "确认密码": "Confirm Password",
  "真实姓名": "Name",
  "手机号码": "Phone Number",
  "取款密码": "Withdrawal password",
  "验证码": "Code",
  "请输入密码": "Please enter the password",
  "请输入验证码": "Please enter the verification code",
  "请输入账号": "Please enter an account",
  "请重新获取验证码": "Please obtain the verification code again",
  "正在登录中": "Logging in",
  "网络异常,请稍后再试": "Network error, please try again later",
  "账号名": "Account name",
  "余额": "Balance",
  "会员中心": "Member",
  "网上存款": "Online deposit",
  "网上提款": "Online withdrawal",
  "退出": "Exit",
  "请再次输入密码": "Please enter the password again",
  "请输入姓名": "Please enter your name",
  "请输入手机号": "Please enter your phone number",
  "请输入取款密码": "Please enter the withdrawal password",
  "正在注册中": "Registering",
  "确定": "Determine",
  "注册成功": "login was successful",
  "热门优惠": "Popular discounts",
  "首页": "Home",
  "查看活动": "View Activities",
  "正在获取活动列表": "Getting activity list",
  "暂无活动": "No activity at the moment",
  "活动详情": "Event Details",
  "视讯直播": "Video live streaming",
  "直播类型": "Live streaming type",
  "热门": "Popular",
  "推荐": "Recommend",
  "最新": "up-to-date",
  "全部": "All",
  "获取类型中": "Obtaining type",
  "获取具体信息中": "Obtaining specific information",
  "开始": "Start",
  "正在获取资源": "Acquiring resources",
  "正在努力加载中": "Trying to load",
  "电子": "Electron",
  "大厅": "Hall",
  "游戏类型": "Game Type",
  "游戏标签": "Game tags",
  "错误的类型": "Wrong type",
  "返回首页": "HomePage",
  "正在获取游戏列表": "Getting game list",
  "暂无游戏": "There are currently no games available",
  "当前未登录,请先登录": "Currently not logged in, please log in first",
  "联系我们": "Contact Us",
  "导航": "navigation",
  "配置文件信息": "Profile Information",
  "常用功能": "Common functions",
  "充值": "Recharge",
  "提现": "Withdrawal",
  "功能列表": "Functions",
  "交易": "Transaction",
  "设置": "set up",
  "修改登入密码": "Change login password",
  "修改提现密码": "Change withdrawal password",
  "银行卡": "Bank Card",
  "若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "If you previously logged in to the site through your phone number or social media platform, please contact customer service directly to assist in setting up",
  "旧密码": "Old password",
  "请输入旧密码": "Please enter your old password",
  "设定新密码": "Set a new password",
  "确认新密码": "Confirm new password",
  "确认": "Confirm",
  "下一步": "Next Step",
  "交易功能": "Trading functions",
  "支付方式": "Payment method",
  "充值教学": "Recharge teaching",
  "选择渠道": "Choose a channel",
  "存款金额": "Deposit",
  "实际金额": "Actual amount",
  "提现币种": "Withdrawal currency",
  "提现银行卡": "Withdrawal of bank card",
  "新增": "Newly added",
  "提现金额": "Withdrawal amount",
  "提现金额范围": "Withdrawal amount range",
  "请输入金额": "Please enter the amount",
  "实际到帐": "Actual receipt",
  "一般手续费": "General handling fees",
  "强制手续费": "Mandatory handling fees",
  "上一步": "Back",
  "修改成功": "Successfully modified",
  "修改中": "Modifying",
  "拼命加载中": "Loading desperately",
  "编辑登录密码": "Edit login password",
  "编辑提款密码": "Edit withdrawal password",
  "如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "If you log in to the website through your phone number or social media platform, please contact customer service for assistance.",
  "请输入新密码": "Please enter a new password",
  "新密码不能和旧密码一致": "The new password cannot match the old password",
  "两次输入密码不一致!": "The two passwords entered do not match!",
  "请输入提款密码": "Please enter the withdrawal password",
  "输入提款密码": "Enter withdrawal password",
  "请设置新的提款密码": "Please set a new withdrawal password",
  "设置6位提款密码，并记住您的密码": "Set a 6-digit withdrawal password and remember your password",
  "请输入新的提款密码": "Please enter a new withdrawal password",
  "存款": "Deposit",
  "取款": "Withdraw",
  "付款方式": "Payment Method",
  "存款金额": "Deposit Amount",
  "请输入金额": "Please enter the amount",
  "下一步": "Next step",
  "提款金额": "Withdrawal Amount",
  "提款银行卡": "Withdrawal Bank Card",
  "请输入您的银行卡号": "Please enter your bank card number",
  "切换语言将会刷新页面": "Switching languages will refresh the page",
  "充值方式": "Recharge method",
  "取消": "cancellation",
  "登录过期,是否重新登录": "Login expired, do you want to log in again",
  "系统提示": "prompted",
  "国家": "Country",
  "请输入": "please input",
  "请选择": "Please select",
  "please-select-method": "Please select payment method",
  "reg-agreement": `I agree with <a href='/' style="color: #E4493B">Privacy</a> and <a href='/' style="color: #E4493B">Policy</a>`,

  //新的一套
  "加载更多": "Load more",
  "开始": "Play",
  // "存取款":"Deposit/Withdrawal",
  "存取款": "Deposit",
  "加钱": "Add money",
  "选择您的奖金": "Select your bonus",
  "100%,最高1500": "100% up to R$1,500",
  "CASINO": "CASINO",
  "Select your lottery": "Select your lottery",
  "don't want a lottery": "don't want a lottery",
  "金额不得小于": "The amount must not be less than",
  "金额不得大于": "Amount cannot be greater than",
  "加载失败": "Load Fail",
  "活动中心": "Activity Center",
  "**财富攀升-BRL的充值促销**": "**Wealth Climbing - Reload Promotion in BRL**",
  "在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "In this unique event, we provide you with an endless opportunity to accumulate wealth. Whether you are a beginner or an experienced user, each recharge will bring you different levels of gifts and higher levels of privileges.",
  "**青铜级别（青铜）**": "**Bronze Grade (Bronze)**",
  "-重新加载的总金额：1.000-5.000 BRL": "- Total amount reloaded: 1.000 - 5.000 BRL",
  "-礼品的比例从5%逐渐增加到10%": "- The proportion of gift gradually increases from 5% to 10%",
  "-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- On the first recharge, you will already receive an exclusive gift. The door to wealth is open. With each additional recharge, more gifts will come.",
  "**银级（银级）**": "**Silver Level (SILVER)**",
  "-重新加载的总金额：5.001-15.000 BRL": "- Total amount reloaded: 5.001 - 15.000 BRL",
  "-礼品的比例从10%逐渐增加到15%": "- The proportion of gift gradually increases from 10% to 15%",
  "-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- You have reached the Silver level where your wealth continues to grow. The more you recharge, the higher the gift ratio. Reload more, earn more!",
  "**黄金级别（Gold）**": "**Gold Level (GOLD)**",
  "-重新加载的总金额：15.001-30.000 BRL": "- Total amount reloaded: 15.001 - 30.000 BRL",
  "-礼品的比例从15%逐渐增加到18%": "- The proportion of gift gradually increases from 15% to 18%",
  "-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- You are on the road of nobility, where wealth abounds. By becoming a Gold member, you will receive more generous gifts. Your wealth is destined to prosper.",
  "**白金级别（白金）**": "**Platinum Level (PLATINUM)**",
  "-随着冷却值的增加，会奖励更多的礼物": "- As the cooldown value increases, more gifts are awarded",
  "-重新加载的总金额：30.001-60.000 BRL": "- Total amount reloaded: 30.001 - 60.000 BRL",
  "-礼品的比例从18%逐渐增加到20%": "- The proportion of gift gradually increases from 18% to 20%",
  "-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- At Platinum level, your recharge will receive a higher proportion of gifts. Your financial mastery becomes even more remarkable, with abundant rewards.",
  "**钻石级别（钻石）**": "**Diamond Level (DIAMOND)**",
  "-重新加载的总金额：60.001-100.000 BRL": "- Total amount reloaded: 60.001 - 100.000 BRL",
  "-礼品比例最高，达到20%": "- The highest proportion of gift, reaching 20%",
  "-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- This is the height of honor, the ultimate choice. By becoming a Diamond member, you will enjoy the highest proportion of gifts, leading your wealth to accelerated growth, and your financial dreams are about to come true.",
  "不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": `Don't miss this incredible opportunity. Climb the ladder of wealth, watch your wealth multiply. Join our "Wealth Climbing" in the BRL Refill Promotion and ensure optimal support to achieve your financial goals. The journey to wealth begins with you, the rewards do not stop growing, success is by your side!`,
  "游戏记录": "Game Record",
  "交易记录": "Transaction records",
  "提交": "submit",
  "游戏品牌": "Game brand",
  "游戏名称": "Game name",
  "下注时间": "Betting time",
  "下注金额": "Bet amount",
  "输赢金额": "Win or loss amount",
  "上一页": "Previous page",
  "下一页": "Next page",
  "申请时间": "Application Time",
  "状态": "State",
  "法规与合作伙伴": "Regulations and Partners",
  "为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "In order to register for this website, users must accept the general terms and conditions. If the terms and conditions are updated, existing users can choose to stop using the products and services before the aforementioned update takes effect, that is, at least two weeks after the update is announced. Tambet911.com is operated by JajajEmmi B.V. with registration number 150790 and its address is Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao. This website is licensed and regulated by Curacao Island Electronic Gaming Company with license number 1668/JAZ.",
  '您可以使用用户名和密码登录': 'You can log in with your username and password',
  '创建账户': 'Create account',
  '银行信息': 'Bank Information',
  '名称': 'Name',
  '时间': 'Time',
  '最小': 'Min',
  '最大': 'Max',
  '即时到账': 'Instant Receipt',
  '选择银行': 'Select Bank',
  '银行账号': 'Bank account number',
  '请输入银行账号': 'Please enter your bank account',
  '金额': 'Amount',
  '支出': 'Payout',
  '输入金额': 'Please enter the amount',
  "暂无数据": "There is currently no data available",
  '获奖人': 'Winner',
  '游戏榜': 'Game Chart',
  '新游戏榜': 'New Game Chart',
  '热门游戏榜': 'Popular Game Ranking',
  '电子游戏': 'Electronic Games',
  '主要余额': 'Main balance',
  '历史记录': 'History',
  '付款名称': 'Payment Name',
  '费用': 'Cost',
  '免费': 'Free',
  '立即生效': 'Effective immediately',
  '银行选择': 'Bank selection',
  '银行账户': 'Bank account',
  '充值金额': 'Enter the amount',
  '收款名称': 'Payment name',
  '账号类型': 'Account type',
  '收账账号': 'Collection account number',
  'CPF号码': 'CPF number',
  '提现密码': 'Withdraw password',
  '请输入名称': 'Please enter a name',
  '请选择类型': 'Please enter the selection type',
  '请输入CPF': 'Please enter CPF',
  '请输入提现金额': 'Please enter the withdrawal amount',
  '请输入正确的参数': 'Please enter the correct parameters',
  "收藏夹":"Favorites",
	"敬请期待":"Coming Soon",
	"用户":"User",
	"玩家":"Player",
	"时间":"Time",
  "赌场":"Casino",
  "体育运动":"Sports",
  "促销":"Promo",
  "支持/法律":"Support/Legal",
  "加入我们的社区":"Join our Community",
  "赌场主页":"Casino Home",
  "插槽":"Slots",
  "现场赌场":"Live Casino",
  "新版本":"New Releases",
  "桌面游戏":"Table Game",
  "体育之家":"Sports Home",
  "会员俱乐部":"VIP Club",
  "优惠促销":"Promotions",
  "赌博意识":"Gamble Aware",
  "常问问题":"FAQ",
  "条款和条件":"Terms and Conditions",
  "隐私政策":"Privacy Policy",
  "赞助和游戏责任":"Sponsorship and Gaming Responsibilities",
  "页脚文本":"BetBlitz sets its sights on achieving global dominance in the realm of online gaming and betting, leveraging state-of-the-art blockchain technologies, and steadfastly prioritizing customer satisfaction. At the heart of our operation lie the principles of trust, integrity, and fairness, guiding our every endeavor.",
  "充电时间":"Recharge Time",
  "订单号":"Order Number",
  "充值金额":"Enter the amount",
  "充值方式":"Recharge Method",
  "地位":"Status",
  
  '负责任的博彩': 'Responsible Gaming',
  '快速链接': 'Quick Links',
  '桌上游戏': 'Table Games',
  '二十一点': 'Blackjack',
  '扑克': 'Poker',
  '百家乐': 'Baccarat',
  '掷骰子': 'Craps',
  '奖金': 'Bonuses',
  '赌场奖金': 'Casino Bonus',
  '自由旋转': 'Free Spin',
	'免费投注': 'Free Bets',
	'信息': 'Information',
  "":"",
  
	"老虎机游戏":"Slot Games",
	"赌场游戏":"Casino Games",
	"更多游戏":"More Games",
  "搜索游戏":"Search Games",
  "特色提供商":"Featured Providers",
  "Logout":"Log out",
  "Personal Center" : "Personal Center",
  "Limit" : "Limit",
  "MessageCenter" : "Message Center",

  'All':'All',
  'Arcade':'Arcade',
  'Bingo':'Bingo',
  'Card':'Card',
  'Casino':'Casino',
  'Crash':'Crash',
  'Fish':'Fish',
  'Live':'Live',
  'Lottery':'Lottery',
  'Slot':'Slot',
  'Sports':'Sports',
  'Video Game':'Video Game',

  'cs-title':'7x24 HOURS',
  'cs-text':'Customer service available to help troubleshoot issues and answer questions.',
  'cs-contact':'Contact',

  'social-media':'Social Media',
  'contact-us':'Contact us through the following',
  
  'footer-line1':'is operated by',
  'footer-line2':'Company registered address',
  'footer-line3':'This product is only for users over the age of 18 and is for entertainment purposes only',
  'footer-line4':'This game contains in-app purchases',
  'footer-line5':'The fact that a player plays or wins in social gambling does not mean that he or she will win in real money gambling and related games in the future',

  
  // Added Lines

  'popup-message':'Do you want to turn off reminders?',
  'sign-up': 'Sign up',
  'member-login': 'Log in',
  'sign-in-message': 'Supports Register Account only',
  'sign-in':'LOG IN',
  'password': 'Password',
  'confirm-password': 'Confirm Password',
  'remember-me': 'Remember Me',
  'forgot-password': 'Forgot Password',
  "sign-in-note":"Don't have an account?",
  "register-note":"Already have an account?",
  "register":"Register",
  "lang-label": "English",
  "app_download": "App Download",
  "hot": "Hot",
  "demo": "Demo",
  "betRecords": "Bet Records",
  "agent": "Agent",
  "faq": "Faq",
  "offers": "Offers",
  
  "popular": "Popular",
  "promotion": "Promotion",
  "follow": "Follow",
  'search':'Search',

  'home':'Home',
  'deposit':'Deposit',
  'withdraw':'Withdraw',
  'profile':'Profile',
  'online-cs':'Customer Service',

  "search-games":"Search Games",
  "search-results":"Search Results",

  'Activity':'Activity',
  'Rebates':'Rebates',
  'VIP':'VIP',
  'History':'History',
  'Cover':'Cover',

  'recharge-activity':'Recharge Activity',
  'time':'Time',
  'reward':'Reward',
  'deposit-value':'Deposit Value',
  'status':'Status',
  'reward-bonus-discription': "Get 10R$ for free after your first deposit of 100R$.",
  'invitaion-activity-discription': "Invite friends and get 100R$ for free.",
  'daily-loss-activity-discription': "8% Daily Cashback",
  'recharge-rebet-activity-discription': "Get 20% cashback for free when you top up 100R$ in a single transaction",
  'user-not-eligible': "You're not eligible for this reward",
  '不符合领取资格': "Not eligible to receive",
  'reward-claimed': "Reward claimed successfully!",
  '没有符合资格的充值': 'No eligible top-ups',

  'invitation-activity':'Invitation Activity',
  'recharge-amount':'Enter the amount',
  'spin':'Spin',
  'bonus':'Bonus',
  'invites':'Invites',
  "install-btn": "INSTALL",

  'daily-loss-relief-fund':'Daily Loss Relief Fund',
  'percent':'Percent',
  "amount-loss": "Amount Loss",

  'recharge-rebate-activity':'Recharge Rebate<br>Activity',
  'recharge-amount':'Enter the amount',
  'return-ratio':'Return ratio',
  'return-amount':'Return amount',
  
  'recharge-note1':'A single recharge of 100 Brazilian reals can participate in the event',
  'recharge-note2':'Each recharge of 100 Brazilian reals or more is independently calculated;',
  'recharge-note3':'This activity requires a minimum of 5 times the Enter the amount to receive rewards;',
  'recharge-note4':'Those who fail to meet the standard or complete the reward collection after the event will not be able to receive the reward again;',
  'recharge-note5':'Failure to avoid causing losses, please complete the task in advance or receive rewards;',
  'recharge-note6':'This activity is limited to the normal operation behavior of account holders and prohibits technical means such as renting, cheating, bots, playing games with different accounts, mutual brushing, arbitration, interfaces, protocols, exploiting vulnerabilities, and group control. Otherwise, rewards will be cancelled, deducted, frozen, or even blacklisted;',
  'recharge-note7':'The interpretation rights of all activities ultimately belong to this platform;',

  'claim':'Claim',

  'lottery-wheel':'Lottery Wheel',
  'number-of-spin':'Number of Spin',
  'spin':'Spin',

  'upgrade-required':'Upgrade required',
  'recharge':'Recharge',
  'betting':'Betting',
  'Bonus':'Bonus',
  'Notification':'Notification',
  'Announcement':'Announcement',
  'Support':'Support',
  'level':'Level',

  'view-data':'View data',
  'current-data':'Current data',
  'last':'Last',
  'days':'days',
  'event':'Event',
  'notes':'Notes',

  'rebate-funds':'Rebate Funds',
  'statement':'Statement',
  'rebate':'Rebate',

  'platform-rebate':'Platform Rebate',
  'action':'Action',
  'type':'Type',
  'amount':'Amount',

  'record':'Record',
  'recharge-method': 'Recharge Method',
  'recharge-note':'If you encounter any problems, please contact us!',
  'withdrawal-note':'If you encounter any problems, please contact us!',
  'online-service':'Online Service',
  'recharge-amount': 'Enter the amount',
  'withdrawal':'withdrawal',
  'online-withdrawal':'Online Withdrawal',
  'withdrawal-method':'Withdrawal Method',
  'fee':'Fee',
  'full-name':'Full Name',
  'please-enter-your':'Please Enter your',
  'name':'Name',
  'collection-account-number':'Collection account number',
  'withdraw-password':'Withdraw Password',
  'phone-number':'Phone Number',
  'security-center':'Security Center',
  'change-password':'Change Password',
  'financial-status':'Financial Status',
  'verify-password':'Verify Password',
  'bind-email-note':'You are binding your email and need to verify your login password',
  'bind-password-note':'You are changing your password and need to login for password verification',
  'next-step':'Next Step',

  'balance':'Balance',
  'information-center':'Information Center',
  'order-center':'Order Center',
  'agency-center':'Agency Center',
  'exit':'Log out',
  'bonus-amount':'Bonus Amount',
  'fee-amount':'Fee Amount',
	'change': 'Change',
  'male':'Male',
  'female':'Female',
  'submit':'Submit',  
  'information':'Information',
  'Details':'Details',
  'Fee':'Fee',
  'Association':'Association',

  'Invite':'Invite',
  'Agent':'Agent',
  'Invitation record':'Invitation record',
  'Invitation':'Invitation',
  'Reward':'Reward',
  'Agency mechanism':'Agency mechanism',
  'Register subordinates':'Register subordinates',
  'my-id':'My ID',
  'inviter-id':'Inviter ID',
  'ordinary-agent':'Ordinary Agent',
  'my-invitation-information':'My invitation information',
  'my-links':'My Links',
  'save-qr-code':'Save QR code',
  'my-invitation-record':'My invitation record',
  'total-number-of-invited-people':'Total number of invited people',
  'direct-reports':'Direct Reports',
  'invitation-rewards':'Invitation rewards',
  'invitation-total-reward':'Invitation total reward',
  'directly-invite-rewards':'Directly invite rewards',
  'indirect-invitation-reward':'Indirect invitation reward',
  'more':'More',

  'invitation-total':'Invitation total',
  'direct-rewards':'Direct rewards',
  'indirect-incentives':'Indirect incentives',
  'no-agent':'No agent to display',
	"no-record": "No record found",
	"no-more-roll": "No more roll remaining",
  'rebate-ration':'Rebate ration',
  'deposit-value':'Deposit value',

  'bet-on':'Bet on',
  'settlement':'Settlement',
  'consumption':'Consumption',
  'agent-text':'Agent Text',
  'reg-sub-text':"After completing the registration, enter the invitee's registered phone number, invitation code, and their UID to bind them.",
  'your-invitation-code':'Your invitation code',
  'UID-of-the-invitee':'UID of the Invitee',
  'user-does-not-exist':'USER DOES NOT EXIST',

  'no-record':'No records found',
  'reg-success':'Your registration has been successfully completed',
  'reg-failed':'Registration Failed',
  'valid-number':'Please enter a valid mobile phone number',
  'valid-pass2':'Passwords did not match',
  'pass-error':'Password must be at least 6 characters',  
  "network-error": "Network error, please try again later",
  'fix-error':'Please fix the error in the form',

  'invalid_phone': 'Please enter the correct mobile phone number.',
}
export default en



// WEBPACK FOOTER //
// ./src/utils/lang/config/english.js